// Shared request/response types for server-side contour nesting.
export interface NestPart {
  id: number;
  filename: string;
  length: number;
  width: number;
  quantity: number;
  preview?: number[][][];
}
interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}
export interface Placement extends Rect {
  partId: number;
  rotated: boolean;
  rotation?: number;
  tx?: number;
  ty?: number;
}
export interface NestedSheet {
  placements: Placement[];
  utilization: number;
}
export interface NestResult {
  spacing?: number;
  edge_margin?: number;
  contour_layouts?: number;
  time_limited?: boolean;
  clearance_allowance?: number;
  sheets: NestedSheet[];
  parts: NestPart[];
  length: number;
  width: number;
  thickness: number;
  quantity: number;
}
export const MAX_NEST_PIECES = 2000;
